// src/components/noteColors.ts
export const noteColors = {
    "A": "#E57373",
    "A#": "#F06292",
    "Bb": "#F06292",
    "B": "#BA68C8",
    "B#": "#64B5F6",
    "Bbb": "#E57373", // Same as A
    "Cb": "#BA68C8",
    "C": "#64B5F6",
    "C#": "#4FC3F7",
    "C##": "#4DB6AC",
    "Cbb": "#F06292", // Same as Bb
    "Db": "#4FC3F7",
    "D": "#4DB6AC",
    "D#": "#81C784",
    "D##": "#DCE775", // Same as E
    "Dbb": "#BA68C8", // Same as C
    "Eb": "#81C784",
    "E": "#DCE775",
    "E#": "#FFD54F",
    "E##": "#FFB74D", // Same as F#
    "Ebb": "#4DB6AC", // Same as D
    "Fb": "#DCE775",
    "F": "#FFD54F",
    "F#": "#FFB74D",
    "F##": "#FF8A65",
    "Fbb": "#81C784", // Same as Eb
    "Gb": "#FFB74D",
    "G": "#FF8A65",
    "G#": "#A1887F",
    "G##": "#E57373", // Same as A
    "Gbb": "#FFD54F", // Same as F
    "Ab": "#A1887F",
    "A##": "#BA68C8", // Same as B
    "Abb": "#FF8A65", // Same as G
};

export const scaleDegreeColors = {
    1: "#E57373",
    2: "#BA68C8",
    3: "#64B5F6",
    4: "#4DB6AC",
    5: "#DCE775",
    6: "#FF8A65",
    7: "#A1887F",
    8: "#F06292",
};
  
// export const noteColors = {
//   // C family
//   "C": "#FF6B6B",  // Soft red
//   "C#": "#FF8E72",
//   "Db": "#FF8E72",

//   // D family
//   "D": "#FFA877",  // Soft orange
//   "D#": "#FFB87C",
//   "Eb": "#FFB87C",

//   // E family
//   "E": "#FFD581",  // Soft yellow
//   "E#": "#F0E68C",
//   "Fb": "#F0E68C",

//   // F family
//   "F": "#C5E17A",  // Yellowish green
//   "F#": "#A0D995",
//   "Gb": "#A0D995",

//   // G family
//   "G": "#7FCDBB",  // Soft teal
//   "G#": "#75BFCA",
//   "Ab": "#75BFCA",

//   // A family
//   "A": "#6FB1D9",  // Soft blue
//   "A#": "#7B93DB",
//   "Bb": "#7B93DB",

//   // B family
//   "B": "#9B77DD",  // Soft purple
//   "B#": "#C77DFF",
//   "Cb": "#C77DFF"
// };

// export const noteColors = {
//   // C family
//   "C": "#FF6B6B",  // Vibrant red-pink
//   "C#": "#FF8063",
//   "Db": "#FF8063",

//   // D family
//   "D": "#FF965B",  // Vibrant orange
//   "D#": "#FFAC53",
//   "Eb": "#FFAC53",

//   // E family
//   "E": "#FFC24B",  // Vibrant yellow-orange
//   "E#": "#FFD643",
//   "Fb": "#FFD643",

//   // F family
//   "F": "#D4E157",  // Vibrant yellow-green
//   "F#": "#97D14F",
//   "Gb": "#97D14F",

//   // G family
//   "G": "#4DD0B3",  // Vibrant teal
//   "G#": "#4BD7E9",
//   "Ab": "#4BD7E9",

//   // A family
//   "A": "#4A9FFF",  // Vibrant blue
//   "A#": "#6B7FFF",
//   "Bb": "#6B7FFF",

//   // B family
//   "B": "#9D5FFF",  // Vibrant purple
//   "B#": "#C66BFF",
//   "Cb": "#C66BFF"
// };


// export const noteColors = {
//   "A": "#EF5350",
//   "A#": "#EC407A",
//   "Bb": "#EC407A",
//   "B": "#AB47BC",
//   "B#": "#42A5F5",
//   "Cb": "#AB47BC",
//   "C": "#42A5F5",
//   "C#": "#29B6F6",
//   "C##": "#26A69A",
//   "Db": "#29B6F6",
//   "D": "#26A69A",
//   "D#": "#66BB6A",
//   "Eb": "#66BB6A",
//   "E": "#D4E157",
//   "E#": "#FFCA28",
//   "Fb": "#D4E157",
//   "F": "#FFCA28",
//   "F#": "#FFA726",
//   "F##": "#FF7043",
//   "Gb": "#FFA726",
//   "G": "#FF7043",
//   "G#": "#8D6E63",
//   "Ab": "#8D6E63",
// };
